module.exports = __webpack_public_path__ + "static/img/ikonaScratch-ON.b8efa31f.png";